import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import moment from 'moment-timezone'

import './AliadaProfile.scss'
import MobileNavBar from 'components/MobileNavBar'
import Avatar from 'components/Avatar'
import AliadaProfileVerifications from 'components/AliadaProfileVerifications'
import AliadaProfileSkills from 'components/AliadaProfileSkills'
import ReviewCard from 'components/ReviewCard'
import AliadaProfileCard from 'components/AliadaProfileCard'
import Loader from 'components/Loader'
import AliadaProfileAvailability from './components/AliadaProfileAvailability'

import { analytics } from '@src/services/Analytics'
import * as paths from 'utils/paths'
import { parse } from 'utils/querystring'
import { formatDate } from 'utils/dates'
import { TIMEZONE } from '@src/globals'

class AliadaProfile extends Component {
  constructor () {
    super()

    this.reserveAliada = this.reserveAliada.bind(this)
  }

  componentWillMount () {
    const { fetchAliada, aliadaId } = this.props
    const {
      estimatedHours,
      serviceTypeId,
      coordinates
    } = parse(this.props.location.search)

    fetchAliada(aliadaId, {
      estimatedHours,
      serviceTypeId,
      coordinates
    })
  }

  componentWillReceiveProps (nextProps) {
    const { fetchAliada, aliadaId } = this.props
    const {
      estimatedHours,
      serviceTypeId,
      coordinates
    } = parse(this.props.location.search)

    if (nextProps.aliadaId !== aliadaId) {
      fetchAliada(nextProps.aliadaId, {
        estimatedHours,
        serviceTypeId,
        coordinates
      })
    }
  }

  componentDidMount () {
    const { aliadaId } = this.props
    analytics.aliadaViewSubmit({ aliadaId })
  }

  reserveAliada (date) {
    const {
      aliadaId,
      updateService,
      push
    } = this.props
    const {
      estimatedHours,
      serviceTypeId
    } = parse(this.props.location.search)

    const parsedDate = formatDate('YYYY-MM-DD', date)
    const parsedTime = formatDate('HH[:00]', date)

    updateService({
      service: {
        aliadaId,
        estimatedHours,
        serviceTypeId,
        date: parsedDate,
        time: parsedTime
      }
    })

    analytics.aliadaChosenSubmit({ aliadaId })

    const addressStepUrl = paths.aliadaReserveAddress(aliadaId)
    push(addressStepUrl)
  }

  render () {
    const {
      fetching,
      error,
      aliadas,
      aliadaId,
      recentRatingsLimit = 3,
      estimatedServiceHours,
      goBack
    } = this.props

    if (error) {
      return (
        <p>Aliada not found</p>
      )
    }

    const aliada = aliadas[aliadaId]
    if (!aliada || fetching) {
      return (
        <Loader className='AliadaProfile-loader' />
      )
    }

    const renderRecentRatings = (aliada) => {
      const ratingItems = aliada.ratings.slice(0, recentRatingsLimit).map(
        (rating) => <ReviewCard key={rating.id} rating={rating} />
      )

      if (!ratingItems.length) return

      return (
        <div className='AliadaProfile-ratings'>
          <h4>Lo que opinan mis clientes</h4>
          <ul className='list-unstyled'>
            {ratingItems}
          </ul>
        </div>
      )
    }

    const renderReserveButton = (aliada) => {
      if (!('availability' in aliada)) {
        const { firstName } = aliada

        return (
          <div className='AliadaProfile-reserve'>
            <button
              onClick={this.reserveAliada}
              className='btn btn-primary btn-block btn-lg'>
              Reserva con {firstName}
            </button>
          </div>
        )
      }
    }

    const renderHeader = (aliada) => {
      return (
        <div className='AliadaProfile-header'>
          <div className='AliadaProfile-profilePicture'>
            <Avatar
              image={aliada.profilePicture.original}
              superaliada={aliada.superaliada}
              size={112} />
          </div>
          <AliadaProfileCard aliada={aliada} estimatedServiceHours={estimatedServiceHours} avatar={false} />
          <AliadaProfileVerifications aliada={aliada} />
          <div className='AliadaProfile-skills'>
            <AliadaProfileSkills aliada={aliada} label='Habilidades:' preferences />
          </div>
        </div>
      )
    }

    const renderAvailability = aliada => {
      if ('availability' in aliada) {
        const {
          date,
          time
        } = parse(this.props.location.search)
        const datetime = moment.tz(`${date} ${time}`, TIMEZONE)
        return (
          <AliadaProfileAvailability
            availability={aliada.availability}
            onDateSelected={this.reserveAliada}
            dateSelected={datetime}
            />
        )
      }
    }

    return (
      <div className='AliadaProfile navbar-screen'>
        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-arrow-back' />
            </Link>
          }
          rightControl={<span className='icon-logo' />}
        >
            Perfil de {aliada.firstName}
        </MobileNavBar>

        <div className='AliadaProfile-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            {renderHeader(aliada)}
            {renderAvailability(aliada)}
            {renderReserveButton(aliada)}
            {renderRecentRatings(aliada)}
          </div>
        </div>
      </div>
    )
  }
}
AliadaProfile.displayName = 'AliadaProfile'
AliadaProfile.propTypes = {
  fetchAliada: PropTypes.func.isRequired,
  updateService: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  aliadas: PropTypes.object.isRequired,
  aliadaId: PropTypes.string.isRequired,
  recentRatingsLimit: PropTypes.number,
  estimatedServiceHours: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired
}

export default AliadaProfile



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/AliadaProfile/AliadaProfile.js